import { render, staticRenderFns } from "./home.vue?vue&type=template&id=0b179ce4&scoped=true&"
import script from "./home.vue?vue&type=script&setup=true&lang=ts&"
export * from "./home.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./home.vue?vue&type=style&index=0&id=0b179ce4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b179ce4",
  null
  
)

export default component.exports